import { ORDER_OPTIONS, QUANTITY_OPTIONS, REGISTRATION_QUANTITY_OPTIONS } from '@/shared/config';
import type { QuantityOption } from '@/shared/config';
import { DocumentType, type EntityType, type OrderOptions } from '@/shared/lib';

export const HOMOLOGATION_DOCUMENT_SEARCH_URL = '/homologations/search';
export const HOMOLOGATION_REGISTRATION_SEARCH_URL = '/matrices/homologations';

/**
 * Tamanho de pagina com que cada aba nasce e para o qual a troca de aba volta.
 *
 * Precisa ser uma das opcoes do seletor: um valor de fora deixa o controle em branco, porque
 * `SelectInput` resolve o rotulo por id exato, e faz o rodape dividir o total que o servidor mandou
 * por um tamanho que ninguem serviu. A aba de Registros ainda devolve 400: `/matrices/homologations`
 * valida `itemsPerPage` contra a mesma lista.
 */
export const HOMOLOGATION_DEFAULT_PAGE_SIZE = QUANTITY_OPTIONS[0].id;

const REVISION_COUNT_SORT = 'revision';

/**
 * `matrices` nao ordena por numero de revisoes: `resolveQueueOrderBy` so conhece `name`, `createdAt`
 * e `prefix`, e qualquer outro campo cai calado no padrao. Deixar a opcao no menu daria um controle
 * que nao faz nada. Mesmo recorte de `approval-list.config.ts`.
 */
const REGISTRATION_ORDER_OPTIONS: OrderOptions[] = ORDER_OPTIONS.filter(
  (option) => option.sort !== REVISION_COUNT_SORT
);

export interface HomologationTabConfig {
  /**
   * Cada aba tem a sua fonte: Documentos le `document_revisions`, Registros le `matrices`.
   *
   * As duas tabelas tem sequencia de id propria, entao o mesmo numero endereca uma linha em cada uma
   * delas. Pedir a fonte errada nao devolve vazio: devolve o item errado. Por isso o endereco vive
   * aqui, amarrado a natureza, e nao num parametro que a tela monta a mao.
   */
  searchUrl: string;
  orderOptions: OrderOptions[];
  emptyTitle: string;
  /** So o rotulo da opcao "todos" muda por aba; os tamanhos sao os mesmos nas duas. */
  quantityOptions: QuantityOption[];
  entityName: EntityType;
}

export const HOMOLOGATION_TAB_CONFIG: Record<DocumentType, HomologationTabConfig> = {
  [DocumentType.DOCUMENT]: {
    searchUrl: HOMOLOGATION_DOCUMENT_SEARCH_URL,
    orderOptions: ORDER_OPTIONS,
    emptyTitle: 'Nenhum documento em homologação no momento',
    quantityOptions: QUANTITY_OPTIONS,
    entityName: 'documento',
  },
  [DocumentType.REGISTRATION]: {
    searchUrl: HOMOLOGATION_REGISTRATION_SEARCH_URL,
    orderOptions: REGISTRATION_ORDER_OPTIONS,
    emptyTitle: 'Nenhum registro em homologação no momento',
    quantityOptions: REGISTRATION_QUANTITY_OPTIONS,
    entityName: 'registro',
  },
};

export const getHomologationTabConfig = (documentType: DocumentType): HomologationTabConfig =>
  Object.prototype.hasOwnProperty.call(HOMOLOGATION_TAB_CONFIG, documentType)
    ? HOMOLOGATION_TAB_CONFIG[documentType]
    : HOMOLOGATION_TAB_CONFIG[DocumentType.DOCUMENT];

export const getHomologationSearchUrl = (documentType: DocumentType): string =>
  getHomologationTabConfig(documentType).searchUrl;
